export const navItems = [
  { label: "Accueil", href: "#home" },
  { label: "À propos", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Prestations", href: "#projects" },
  { label: "Témoignages", href: "#testimonials" },
  { label: "FAQ", href: "#faqs" },
  { label: "Engagements", href: "#engagements" },
  { label: "Contact", href: "#contact", highlighted: true },
];

export const services = [
  {
    title: "Récupération de métaux",
    description: "Transformez vos déchets métalliques en opportunités !",
    image: "service-recuperation-metaux.png",
    delay: "0.25s",
  },
  {
    title: "Recyclage de métaux",
    description: "Recyclez vos métaux avec des experts engagés.",
    image: "service-recyclage-metaux.png",
    delay: "0.5s",
  },
  {
    title: "Rachat de métaux",
    description: "Valorisez vos ressources dès aujourd'hui !",
    image: "service-rachat-metaux.png",
    delay: "0.75s",
  },
];

export const reasons = [
  {
    title: "Expertise et Expérience",
    subtitle: "Des professionnels aguerris à votre service",
    points: [
      "Plus de 15 ans d’expérience dans l’achat, la vente et le recyclage des métaux.",
      "Une équipe formée aux normes environnementales et aux procédés industriels les plus stricts.",
      "Conseil personnalisé pour maximiser la valeur de vos métaux.",
    ],
    icon: "icon-why-choose-1.svg",
    image: "why-choose-img-1.jpeg",
  },
  {
    title: "Solutions Innovantes",
    subtitle: "Des méthodes de pointe pour un recyclage optimal",
    points: [
      "Tri automatisé et analyse de composition pour une valorisation précise.",
      "Partenariats technologiques avec des centres de recyclage certifiés.",
      "Solutions sur mesure pour les professionnels (chantiers, industries, démolitions).",
    ],
    icon: "icon-why-choose-2.svg",
    image: "why-choose-img-2.jpeg",
  },
  {
    title: "Qualité et Professionnalisme",
    subtitle: "Un service irréprochable, de la collecte à la livraison",
    points: [
      "Devis transparent sans frais cachés.",
      "Collecte rapide et logistique optimisée (camions dédiés, horaires flexibles).",
      "Paiement sécurisé et traçabilité totale de vos métaux.",
    ],
    icon: "icon-why-choose-3.svg",
    image: "why-choose-img-3.jpeg",
  },
];

export const projects = [
  {
    title: "Câbles électriques",
    description: "Collecte et valorisation de câbles électriques usagés.",
    image: "prestation-cables-electriques.png",
    delay: "0.25s",
  },
  {
    title: "Câbles industriels",
    description: "Rachat de câbles industriels issus des chantiers et ateliers.",
    image: "prestation-cables-industriels.png",
    delay: "0.5s",
  },
  {
    title: "Batteries usagées",
    description: "Prise en charge des batteries pour un traitement adapté.",
    image: "prestation-batteries.png",
    delay: "0.75s",
  },
  {
    title: "Fils et câbles mélangés",
    description: "Tri et recyclage de fils électriques de différentes catégories.",
    image: "prestation-fils-melanges.png",
    delay: "1s",
  },
  {
    title: "Cuivre",
    description: "Valorisation du cuivre pour un meilleur prix de reprise.",
    image: "prestation-cuivre.png",
    delay: "1.25s",
  },
  {
    title: "Câbles colorés",
    description: "Collecte de câbles souples et multicolores à recycler.",
    image: "prestation-cables-colores.png",
    delay: "1.5s",
  },
];

export const testimonials = [
  { name: "johan duo", role: "project manager", image: "author-1.jpg" },
  { name: "Jane Smith", role: "interior designer", image: "author-2.jpg" },
  { name: "chris martinez", role: "logistics coordinator", image: "author-3.jpg" },
  { name: "alis white", role: "structural engineer", image: "author-4.jpg" },
];

export const faqs = [
  {
    question: "Proposez-vous un devis gratuit et sans engagement ?",
    answer:
      "Oui. Nous proposons un devis gratuit et détaillé selon la quantité, le type de métal et vos besoins de collecte.",
    collapseId: "collapseOne",
    headingId: "headingOne",
    isOpen: true,
    delay: "0.25s",
  },
  {
    question: "Quels services proposez-vous ?",
    answer:
      "Nous assurons l’achat, la collecte, le tri et le recyclage des métaux ferreux et non ferreux.",
    collapseId: "collapseTwo",
    headingId: "headingTwo",
    delay: "0.5s",
  },
  {
    question: "Quels types de métaux acceptez-vous ?",
    answer:
      "Nous acceptons notamment la ferraille, le cuivre, l’aluminium, le laiton, les câbles et les batteries.",
    collapseId: "collapseThree",
    headingId: "headingThree",
    delay: "0.75s",
  },
  {
    question: "Comment démarrer avec Valmétaux ?",
    answer:
      "Contactez-nous par téléphone, email ou formulaire. Nous évaluons votre besoin, planifions la collecte et vous accompagnons jusqu’au paiement.",
    collapseId: "collapsefour",
    headingId: "headingfour",
    delay: "1s",
  },
];

export const engagements = [
  {
    title: "Recyclage responsable",
    description:
      "Nous valorisons les métaux dans une démarche respectueuse de l’environnement et des normes en vigueur.",
    delay: "0.25s",
  },
  {
    title: "Devis transparent",
    description:
      "Chaque estimation est claire, détaillée et sans frais cachés pour vous permettre de décider en toute confiance.",
    delay: "0.5s",
  },
  {
    title: "Collecte et paiement rapides",
    description:
      "Nous organisons une collecte efficace et assurons un paiement sécurisé après valorisation de vos métaux.",
    delay: "0.75s",
  },
];

export const footerServices = [
  "Récupération de métaux",
  "Recyclage de métaux",
  "Rachat de métaux",
];
